import React from 'react'

import { Document } from 'domain/entities/document'
import DocumentCard from '../DocumentCard'
import * as S from './styles'

type CertificationsProps = {
  certifications?: Document[]
  doctor_id: number
}

const Certifications = ({
  certifications = [],
  doctor_id
}: CertificationsProps) => {
  return (
    <S.Wrapper data-testid="card-certifications">
      <S.CertificationsContainer>
        {certifications &&
          certifications.map((document) => (
            <S.Certification key={document.document_id}>
              <p>{document.type}</p>
              <DocumentCard document={document} doctor_id={doctor_id} />
              {/*<TextField*/}
              {/*  label="Data de expiração"*/}
              {/*  value={document.conclusionDate}*/}
              {/*  required*/}
              {/*  disabled*/}
              {/*  style={{ maxWidth: '324px', marginTop: '16px' }}*/}
              {/*/>*/}
            </S.Certification>
          ))}
      </S.CertificationsContainer>
    </S.Wrapper>
  )
}

export default Certifications
